var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.index},[_c('div',{staticClass:"mapBox",style:('padding:' + _vm.options.data.pageCss.page_css_padding + 
  ';margin:' + _vm.options.data.pageCss.page_css_margin + 
  ';border-radius:' + _vm.options.data.pageCss.page_css_radius + 
  'px;'+_vm.options.data.pageCss.myCss)},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map_container_home"},[_c('div',{attrs:{"id":"map_container"}})])
}]

export { render, staticRenderFns }